import React from "react";

const Arrow = (parent) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor"
		     className="bi bi-arrow-right-square" viewBox="0 0 16 16" className="d-inline-block  ml-3 mr-3">
			<path fillRule="evenodd"
			      d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm4.5 5.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"/>
		</svg>
	);
};

export default Arrow;
